/**
 * Logomark bloom class for Aria chat surfaces.
 * Standalone Ask Aria and portal Aptive Index share the same brand palette (plum violet).
 */
export type AriaChatBrandClass = 'aria-chat-brand-ask-aria' | 'aria-chat-brand-aptive';

export function ariaChatBrandClass(_isStandalone?: boolean): AriaChatBrandClass {
  return 'aria-chat-brand-aptive';
}
